<template>
  <div id="app">
    <div
      style="display: flex;justify-content: space-between;align-items: center;height:50px;padding: 0 20px;border-bottom:1px #ccc solid">
      <div style="display:flex;align-items:center"><img style="width:36px;height:36px" src="../assets/4Gicon.png" alt=""
          srcset="">
        报表中心管理后台</div>
      <div style="display:flex;">
        <el-button type="text" @click="outLogin" style="margin-right:20px">退出登录</el-button>
        <div
          style="background-color:blue;width: 30px;height:30px;border-radius:50%;line-height:30px;text-align:center;color:white">
          A</div>
      </div>
    </div>
    <div style="display:flex">
      <aside style="width:200px;text-align:left">
        <el-menu router class="el-menu-vertical-demo" style="height:calc(100vh - 51px);width: 200px;"
          :default-active="$route.path" :unique-opened="true" active-text-color="#409EFF">
          <el-submenu index="1">
            <template slot="title">
              <img v-if="$route.path === '/bandlist'" src="@/assets/xiangji.png">
              <img v-else src="@/assets/xiangji_default.png">
              <span>品牌管理</span>
            </template>
            <el-menu-item index="/bandlist">品牌列表</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <img v-if="$route.path === '/agentlist'" src="@/assets/SIM.png">
              <img v-else src="@/assets/SIM_default.png">
              <span>站点管理</span>
            </template>
            <el-menu-item index="/agentlist">站点管理</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <img v-if="$route.path === '/userslist'" src="@/assets/tupian.png">
              <img v-else src="@/assets/tupian_default.png">
              <span>用户管理</span>
            </template>
            <el-menu-item index="/userslist">用户列表</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <img v-if="$route.path === '/dataplist'" src="@/assets/tupian.png">
              <img v-else src="@/assets/tupian_default.png">
              <span>数据权限</span>
            </template>
            <el-menu-item index="/dataplist">权限列表</el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">
              <img v-if="$route.path === '/usermanage'||$route.path === '/authority'" src="@/assets/setting.png">
              <img v-else src="@/assets/setting_default.png">
              <span>设置</span>
            </template>
            <el-menu-item index="/usermanage">账号管理</el-menu-item>
            <el-menu-item index="/authority">权限管理</el-menu-item>
          </el-submenu>
        </el-menu>
      </aside>
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item v-for="(item,key) in breadcrumb" :key="key" :to="{ name: item.name }">{{ item.name }}</el-breadcrumb-item>
</el-breadcrumb> -->
      <div style="flex-grow:1;height:calc(-51px + 100vh)">
        <keep-alive :max="1">
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  // import serialport from 'serialport'

  // import fs from 'fs'

  export default {
    name: 'App',
    data () {
      return {
        // breadcrumb:[]
      }
    },
    methods: {
      toUrl (e) {
        this.$router.push({ path: e });
      },
      outLogin () {
        this.$confirm('确认退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.defaults.headers.common['Authorization'] = '';
          this.$router.push({ path: '/login' });
        })
      }
    },
    computed:{
     
    },
    watch: {

    },

    mounted () {
    }

  }
</script>

<style scoped>
  body {
    margin: 0;
  }

  .el-menu-item /deep/ {
    padding-left: 48px !important;
  }

  .el-menu img {
    width: 24px;
    height: 22px;
    margin-right: 5px
  }

</style>